export default __webpack_public_path__ + "static/media/HelveticaNeue.de0dc798.woff2";